import { appInsightsTelemetry } from "./telemetryAppInsights";
import { gtmTelemetry } from "./telemetryGtm";
import { TelemetryUser } from "./telemetryUser";
import type { detect } from "detect-browser";

type DetectedBrowser = ReturnType<typeof detect>;

let currentUser: TelemetryUser | undefined;
let currentUserKey: string | undefined;
type TelemetryProvider = {
  init: () => void;
  trackException: (
    uuid: string,
    errorMessage: string,
    browserType: DetectedBrowser,
    user: TelemetryUser | null,
    router: unknown
  ) => void;
  endUser: () => void;
  beginUser: (user: TelemetryUser) => void;
};

const telemetry: TelemetryProvider[] = [];

if (appInsightsTelemetry) telemetry.push(appInsightsTelemetry);

if (gtmTelemetry) telemetry.push(gtmTelemetry);

export const telemetryInit = () => {
  try {
    currentUser = undefined;
    telemetry.forEach((t) => t.init());
  } catch {
    // Don't allow telemetry errors to impact the application
  }
};

export const trackException = (
  uuid: string,
  errorMessage: string,
  browserType: DetectedBrowser,
  router: unknown
) => {
  try {
    telemetry.forEach((t) =>
      t.trackException(
        uuid,
        errorMessage,
        browserType,
        currentUser ?? null,
        router
      )
    );
  } catch {
    // Don't allow telemetry errors to impact the application
  }
};

export const telemetryEndUser = () => {
  try {
    if (currentUser) {
      currentUser = undefined;
      currentUserKey = undefined;
      telemetry.forEach((t) => t.endUser());
    }
  } catch {
    // Don't allow telemetry errors to impact the application
  }
};

export const telemetryBeginUser = (
  user: TelemetryUser
) => {
  try {
    if (!user?.userEmail) return;

    // Includes identity/tenant fields, not just email, so switching account/tenant/
    // storefront under the same signed-in user still re-registers - matching CS's
    // telemetryBeginUser (utils/telemetry.ts), which dedupes the same way for the same
    // reason.
    const key = `${user.userEmail}:${user.userId}:${user.employeeId}:${user.impersonatedBy}:${user.isVirtualAdmin}:${user.tenantId}:${user.accountGroupId}:${user.storefrontId}:${user.isGuestUser}:${JSON.stringify(user.salesOrg)}:${user.isIdentityComplete}`;
    if (currentUserKey && currentUserKey === key) return;

    currentUser = user;
    currentUserKey = key;
    telemetry.forEach((t) => t.beginUser(user));
  } catch {
    // Don't allow telemetry errors to impact the application
  }
};
